import firebase from '@firebase/app';

export const registerSectionFirebase = (uidProfessor, section, callback) => {
  section.date_create = firebase.firestore.FieldValue.serverTimestamp();

  if (!section.training) {
    let refUidTraining = firebase.firestore().collection("professors").doc(uidProfessor)
      .collection("trainings").doc();
    let uidTraining = refUidTraining.id;
    console.log("Novo id gerado: " + uidTraining);
    section.training = uidTraining;
  }

  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("sections").add(section)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, section.training, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const registerTraining = (uidProfessor, training, callback) => {
  training.date_create = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("trainings").add(training)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const saveBkpTrainingTxt = (uidProfessor, text, callback) => {
  text.date_create = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("bkp_trainings").add(text)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}


export const registerSectionsInTraining = (uidProfessor, uidTraining, training, callback) => {
  training.date_create = firebase.firestore.FieldValue.serverTimestamp();
  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("trainings").doc(uidTraining).set(training)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const trainingList = (uidProfessor, callback) => {
  return firebase.firestore().collection("professors").doc(uidProfessor)
    .collection("trainings").orderBy("name", "asc")
    .onSnapshot((snapshot) => {
      let itens = []
      snapshot.forEach(doc => {
        //console.log(doc.id, '=>', doc.data());
        itens.push({
          id: doc.id,
          data: doc.data(),
        })
      });
      callback(itens)
    }, (error) => {
      console.log('Error getting documents', error);
    });

}

export const fetchTrainingById = (uidProfessor, uidTraining, callback) => {
  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("trainings")
    .doc(uidTraining).get()
    .then((doc) => {
      console.log(doc.data())
      let training = {
        id: doc.id,
        data: doc.data(),
      }
      callback(training, true)
    }, (error) => {
      console.log('Error getting documents', error);
      callback(error, false)
    });

}

export const deleteTraining = (uidProfessor, training, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("trainings")
    .doc(training.id)
    .delete()
    .then(function () {
      console.log("Document successfully deleted!");
      callback(true);
    }).catch(function (error) {
      console.error("Error removing document: ", error);
      callback(false);
    });
}



// WEBPACK FOOTER //
// src/dao-firebase/training-daofirebae.js